// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  GenericApiResponseListTask,
  GenericApiResponseNoneType,
  GenericApiResponseTask,
  GetEventTasksForLecturerParams,
  GetTaskByCourseModuleParams,
  GetTaskByModuleVersionParams,
  GetTasksByCourseModuleParams,
  GetTasksByModuleVersionParams,
  GetTasksByUserCourseModuleParams,
  HTTPValidationError,
  TaskCreateRequest,
  TaskUpdateRequest,
} from '../../models';

/**
 * List event-delivered tasks a lecturer is responsible for via mandates.
 * @summary Get Event Tasks For Lecturer
 */
export const getEventTasksForLecturer = (
  lecturerId: string,
  params?: GetEventTasksForLecturerParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListTask>> => {
  return axios.get(`/users/${lecturerId}/event-tasks`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetEventTasksForLecturerQueryKey = (lecturerId: string, params?: GetEventTasksForLecturerParams) => {
  return [`/users/${lecturerId}/event-tasks`, ...(params ? [params] : [])] as const;
};

export const getGetEventTasksForLecturerQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventTasksForLecturer>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  lecturerId: string,
  params?: GetEventTasksForLecturerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTasksForLecturer>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEventTasksForLecturerQueryKey(lecturerId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventTasksForLecturer>>> = ({ signal }) =>
    getEventTasksForLecturer(lecturerId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!lecturerId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventTasksForLecturer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEventTasksForLecturerQueryResult = NonNullable<Awaited<ReturnType<typeof getEventTasksForLecturer>>>;
export type GetEventTasksForLecturerQueryError = AxiosError<void | HTTPValidationError>;

export function useGetEventTasksForLecturer<
  TData = Awaited<ReturnType<typeof getEventTasksForLecturer>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  lecturerId: string,
  params: undefined | GetEventTasksForLecturerParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTasksForLecturer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getEventTasksForLecturer>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEventTasksForLecturer<
  TData = Awaited<ReturnType<typeof getEventTasksForLecturer>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  lecturerId: string,
  params?: GetEventTasksForLecturerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTasksForLecturer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getEventTasksForLecturer>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEventTasksForLecturer<
  TData = Awaited<ReturnType<typeof getEventTasksForLecturer>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  lecturerId: string,
  params?: GetEventTasksForLecturerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTasksForLecturer>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Event Tasks For Lecturer
 */

export function useGetEventTasksForLecturer<
  TData = Awaited<ReturnType<typeof getEventTasksForLecturer>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  lecturerId: string,
  params?: GetEventTasksForLecturerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTasksForLecturer>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEventTasksForLecturerQueryOptions(lecturerId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get tasks for a module, optionally for a specific module version.
If version is provided, tasks for that module version are returned;
otherwise, tasks for the current module are returned.
 * @summary Get Tasks By Module
 */
export const getTasksByCourseModule = (
  courseId: string | null,
  moduleId: string,
  params?: GetTasksByCourseModuleParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListTask>> => {
  return axios.get(`/courses/${courseId}/modules/${moduleId}/tasks`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetTasksByCourseModuleQueryKey = (
  courseId: string | null,
  moduleId: string,
  params?: GetTasksByCourseModuleParams,
) => {
  return [`/courses/${courseId}/modules/${moduleId}/tasks`, ...(params ? [params] : [])] as const;
};

export const getGetTasksByCourseModuleQueryOptions = <
  TData = Awaited<ReturnType<typeof getTasksByCourseModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string | null,
  moduleId: string,
  params?: GetTasksByCourseModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByCourseModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTasksByCourseModuleQueryKey(courseId, moduleId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasksByCourseModule>>> = ({ signal }) =>
    getTasksByCourseModule(courseId, moduleId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(courseId && moduleId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTasksByCourseModule>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTasksByCourseModuleQueryResult = NonNullable<Awaited<ReturnType<typeof getTasksByCourseModule>>>;
export type GetTasksByCourseModuleQueryError = AxiosError<void | HTTPValidationError>;

export function useGetTasksByCourseModule<
  TData = Awaited<ReturnType<typeof getTasksByCourseModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string | null,
  moduleId: string,
  params: undefined | GetTasksByCourseModuleParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByCourseModule>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getTasksByCourseModule>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTasksByCourseModule<
  TData = Awaited<ReturnType<typeof getTasksByCourseModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string | null,
  moduleId: string,
  params?: GetTasksByCourseModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByCourseModule>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getTasksByCourseModule>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTasksByCourseModule<
  TData = Awaited<ReturnType<typeof getTasksByCourseModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string | null,
  moduleId: string,
  params?: GetTasksByCourseModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByCourseModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Tasks By Module
 */

export function useGetTasksByCourseModule<
  TData = Awaited<ReturnType<typeof getTasksByCourseModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string | null,
  moduleId: string,
  params?: GetTasksByCourseModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByCourseModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTasksByCourseModuleQueryOptions(courseId, moduleId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get tasks for a module, optionally for a specific module version.
If version is provided, tasks for that module version are returned;
otherwise, tasks for the current module are returned.
 * @summary Get Tasks By Module
 */
export const getTasksByUserCourseModule = (
  userId: string | null,
  courseId: string | null,
  moduleId: string,
  params?: GetTasksByUserCourseModuleParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListTask>> => {
  return axios.get(`/users/${userId}/courses/${courseId}/modules/${moduleId}/tasks`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetTasksByUserCourseModuleQueryKey = (
  userId: string | null,
  courseId: string | null,
  moduleId: string,
  params?: GetTasksByUserCourseModuleParams,
) => {
  return [`/users/${userId}/courses/${courseId}/modules/${moduleId}/tasks`, ...(params ? [params] : [])] as const;
};

export const getGetTasksByUserCourseModuleQueryOptions = <
  TData = Awaited<ReturnType<typeof getTasksByUserCourseModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string | null,
  courseId: string | null,
  moduleId: string,
  params?: GetTasksByUserCourseModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByUserCourseModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTasksByUserCourseModuleQueryKey(userId, courseId, moduleId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasksByUserCourseModule>>> = ({ signal }) =>
    getTasksByUserCourseModule(userId, courseId, moduleId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(userId && courseId && moduleId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTasksByUserCourseModule>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTasksByUserCourseModuleQueryResult = NonNullable<Awaited<ReturnType<typeof getTasksByUserCourseModule>>>;
export type GetTasksByUserCourseModuleQueryError = AxiosError<void | HTTPValidationError>;

export function useGetTasksByUserCourseModule<
  TData = Awaited<ReturnType<typeof getTasksByUserCourseModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string | null,
  courseId: string | null,
  moduleId: string,
  params: undefined | GetTasksByUserCourseModuleParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByUserCourseModule>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getTasksByUserCourseModule>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTasksByUserCourseModule<
  TData = Awaited<ReturnType<typeof getTasksByUserCourseModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string | null,
  courseId: string | null,
  moduleId: string,
  params?: GetTasksByUserCourseModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByUserCourseModule>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getTasksByUserCourseModule>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTasksByUserCourseModule<
  TData = Awaited<ReturnType<typeof getTasksByUserCourseModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string | null,
  courseId: string | null,
  moduleId: string,
  params?: GetTasksByUserCourseModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByUserCourseModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Tasks By Module
 */

export function useGetTasksByUserCourseModule<
  TData = Awaited<ReturnType<typeof getTasksByUserCourseModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  userId: string | null,
  courseId: string | null,
  moduleId: string,
  params?: GetTasksByUserCourseModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByUserCourseModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTasksByUserCourseModuleQueryOptions(userId, courseId, moduleId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get tasks for a module, optionally for a specific module version.
If version is provided, tasks for that module version are returned;
otherwise, tasks for the current module are returned.
 * @summary Get Tasks By Module
 */
export const getTasksByModuleVersion = (
  moduleId: string,
  version: string | null,
  params?: GetTasksByModuleVersionParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListTask>> => {
  return axios.get(`/modules/${moduleId}/versions/${version}/tasks`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetTasksByModuleVersionQueryKey = (
  moduleId: string,
  version: string | null,
  params?: GetTasksByModuleVersionParams,
) => {
  return [`/modules/${moduleId}/versions/${version}/tasks`, ...(params ? [params] : [])] as const;
};

export const getGetTasksByModuleVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof getTasksByModuleVersion>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  version: string | null,
  params?: GetTasksByModuleVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByModuleVersion>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTasksByModuleVersionQueryKey(moduleId, version, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasksByModuleVersion>>> = ({ signal }) =>
    getTasksByModuleVersion(moduleId, version, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(moduleId && version), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTasksByModuleVersion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTasksByModuleVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getTasksByModuleVersion>>>;
export type GetTasksByModuleVersionQueryError = AxiosError<void | HTTPValidationError>;

export function useGetTasksByModuleVersion<
  TData = Awaited<ReturnType<typeof getTasksByModuleVersion>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  version: string | null,
  params: undefined | GetTasksByModuleVersionParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByModuleVersion>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getTasksByModuleVersion>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTasksByModuleVersion<
  TData = Awaited<ReturnType<typeof getTasksByModuleVersion>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  version: string | null,
  params?: GetTasksByModuleVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByModuleVersion>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getTasksByModuleVersion>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTasksByModuleVersion<
  TData = Awaited<ReturnType<typeof getTasksByModuleVersion>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  version: string | null,
  params?: GetTasksByModuleVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByModuleVersion>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Tasks By Module
 */

export function useGetTasksByModuleVersion<
  TData = Awaited<ReturnType<typeof getTasksByModuleVersion>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  version: string | null,
  params?: GetTasksByModuleVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksByModuleVersion>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTasksByModuleVersionQueryOptions(moduleId, version, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a task in a specific module version
 * @summary Create Task
 */
export const createTask = (
  moduleId: string,
  version: string,
  taskCreateRequest: TaskCreateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseTask>> => {
  return axios.post(`/modules/${moduleId}/versions/${version}/tasks`, taskCreateRequest, options);
};

export const getCreateTaskMutationOptions = <
  TData = Awaited<ReturnType<typeof createTask>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: TaskCreateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['createTask'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTask>>,
    { moduleId: string; version: string; data: TaskCreateRequest }
  > = (props) => {
    const { moduleId, version, data } = props ?? {};

    return createTask(moduleId, version, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: TaskCreateRequest },
    TContext
  >;
};

export type CreateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createTask>>>;
export type CreateTaskMutationBody = TaskCreateRequest;
export type CreateTaskMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Create Task
 */
export const useCreateTask = <
  TData = Awaited<ReturnType<typeof createTask>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: TaskCreateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { moduleId: string; version: string; data: TaskCreateRequest }, TContext> => {
  const mutationOptions = getCreateTaskMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * get single task
 * @summary Get One Task
 */
export const getTaskByCourseModule = (
  courseId: string | null,
  moduleId: string,
  taskId: string,
  params?: GetTaskByCourseModuleParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseTask>> => {
  return axios.get(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetTaskByCourseModuleQueryKey = (
  courseId: string | null,
  moduleId: string,
  taskId: string,
  params?: GetTaskByCourseModuleParams,
) => {
  return [`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}`, ...(params ? [params] : [])] as const;
};

export const getGetTaskByCourseModuleQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaskByCourseModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string | null,
  moduleId: string,
  taskId: string,
  params?: GetTaskByCourseModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskByCourseModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTaskByCourseModuleQueryKey(courseId, moduleId, taskId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskByCourseModule>>> = ({ signal }) =>
    getTaskByCourseModule(courseId, moduleId, taskId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(courseId && moduleId && taskId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTaskByCourseModule>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTaskByCourseModuleQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskByCourseModule>>>;
export type GetTaskByCourseModuleQueryError = AxiosError<void | HTTPValidationError>;

export function useGetTaskByCourseModule<
  TData = Awaited<ReturnType<typeof getTaskByCourseModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string | null,
  moduleId: string,
  taskId: string,
  params: undefined | GetTaskByCourseModuleParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskByCourseModule>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getTaskByCourseModule>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTaskByCourseModule<
  TData = Awaited<ReturnType<typeof getTaskByCourseModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string | null,
  moduleId: string,
  taskId: string,
  params?: GetTaskByCourseModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskByCourseModule>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getTaskByCourseModule>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTaskByCourseModule<
  TData = Awaited<ReturnType<typeof getTaskByCourseModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string | null,
  moduleId: string,
  taskId: string,
  params?: GetTaskByCourseModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskByCourseModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get One Task
 */

export function useGetTaskByCourseModule<
  TData = Awaited<ReturnType<typeof getTaskByCourseModule>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string | null,
  moduleId: string,
  taskId: string,
  params?: GetTaskByCourseModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskByCourseModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTaskByCourseModuleQueryOptions(courseId, moduleId, taskId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * get single task
 * @summary Get One Task
 */
export const getTaskByModuleVersion = (
  moduleId: string,
  moduleVersion: string | null,
  taskId: string,
  params?: GetTaskByModuleVersionParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseTask>> => {
  return axios.get(`/modules/${moduleId}/versions/${moduleVersion}/tasks/${taskId}`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetTaskByModuleVersionQueryKey = (
  moduleId: string,
  moduleVersion: string | null,
  taskId: string,
  params?: GetTaskByModuleVersionParams,
) => {
  return [`/modules/${moduleId}/versions/${moduleVersion}/tasks/${taskId}`, ...(params ? [params] : [])] as const;
};

export const getGetTaskByModuleVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaskByModuleVersion>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  moduleVersion: string | null,
  taskId: string,
  params?: GetTaskByModuleVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskByModuleVersion>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTaskByModuleVersionQueryKey(moduleId, moduleVersion, taskId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskByModuleVersion>>> = ({ signal }) =>
    getTaskByModuleVersion(moduleId, moduleVersion, taskId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(moduleId && moduleVersion && taskId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTaskByModuleVersion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTaskByModuleVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskByModuleVersion>>>;
export type GetTaskByModuleVersionQueryError = AxiosError<void | HTTPValidationError>;

export function useGetTaskByModuleVersion<
  TData = Awaited<ReturnType<typeof getTaskByModuleVersion>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  moduleVersion: string | null,
  taskId: string,
  params: undefined | GetTaskByModuleVersionParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskByModuleVersion>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getTaskByModuleVersion>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTaskByModuleVersion<
  TData = Awaited<ReturnType<typeof getTaskByModuleVersion>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  moduleVersion: string | null,
  taskId: string,
  params?: GetTaskByModuleVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskByModuleVersion>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getTaskByModuleVersion>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTaskByModuleVersion<
  TData = Awaited<ReturnType<typeof getTaskByModuleVersion>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  moduleVersion: string | null,
  taskId: string,
  params?: GetTaskByModuleVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskByModuleVersion>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get One Task
 */

export function useGetTaskByModuleVersion<
  TData = Awaited<ReturnType<typeof getTaskByModuleVersion>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  moduleId: string,
  moduleVersion: string | null,
  taskId: string,
  params?: GetTaskByModuleVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskByModuleVersion>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTaskByModuleVersionQueryOptions(moduleId, moduleVersion, taskId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a task
 * @summary Update Task
 */
export const updateTask = (
  moduleId: string,
  version: string,
  taskId: string,
  taskUpdateRequest: TaskUpdateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseTask>> => {
  return axios.put(`/modules/${moduleId}/versions/${version}/tasks/${taskId}`, taskUpdateRequest, options);
};

export const getUpdateTaskMutationOptions = <
  TData = Awaited<ReturnType<typeof updateTask>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: TaskUpdateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['updateTask'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTask>>,
    { moduleId: string; version: string; taskId: string; data: TaskUpdateRequest }
  > = (props) => {
    const { moduleId, version, taskId, data } = props ?? {};

    return updateTask(moduleId, version, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: TaskUpdateRequest },
    TContext
  >;
};

export type UpdateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof updateTask>>>;
export type UpdateTaskMutationBody = TaskUpdateRequest;
export type UpdateTaskMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Update Task
 */
export const useUpdateTask = <
  TData = Awaited<ReturnType<typeof updateTask>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: TaskUpdateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; taskId: string; data: TaskUpdateRequest },
  TContext
> => {
  const mutationOptions = getUpdateTaskMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * delete task
 * @summary Delete Task
 */
export const deleteTask = (
  moduleId: string,
  version: string,
  taskId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseNoneType>> => {
  return axios.delete(`/modules/${moduleId}/versions/${version}/tasks/${taskId}`, options);
};

export const getDeleteTaskMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteTask>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; version: string; taskId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['deleteTask'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTask>>,
    { moduleId: string; version: string; taskId: string }
  > = (props) => {
    const { moduleId, version, taskId } = props ?? {};

    return deleteTask(moduleId, version, taskId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string },
    TContext
  >;
};

export type DeleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTask>>>;

export type DeleteTaskMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Delete Task
 */
export const useDeleteTask = <
  TData = Awaited<ReturnType<typeof deleteTask>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; version: string; taskId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { moduleId: string; version: string; taskId: string }, TContext> => {
  const mutationOptions = getDeleteTaskMutationOptions(options);

  return useMutation(mutationOptions);
};
